module.exports = __webpack_public_path__ + "img/gb9877_1-88-15x26x7.prt.3b1b774b.jpg";